import { useState } from "react";
import { FaStar } from "react-icons/fa";

const colors = {
  orange: "#df6c26",
  grey: "#a9a9a9"
};

///**
///   !!! DO NOT REMOVE eslint related INLINE COMMENTS IN BELOW FUNCTION
///**
function NPSApp() {
  const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(undefined);
  const [isEnabled, setIsEnabled] = useState(false);
 
  const stars = Array(5).fill(0);
 
  const handleClick = value => {
    setCurrentValue(value);
    var anyStarChoosen = value > 0;
    setIsEnabled(anyStarChoosen);
  };

  const handleMouseOver = newHoverValue => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  const handleSubmit = async () => { 
    if (await isJsHandlersRegistered())
    {
      jsEventHandlers.submitButton_Click(currentValue, comment);  // eslint-disable-line
      return;
    }

    // if jsEventHandlers is not defined in the browser instance, then we can
    // assume this is running in the context of a newer version of EHR which 
    // handles dispatchEvent
    let submitClickEvent = new CustomEvent("SubmitClick", { 
      detail: {
        score: currentValue,
        feedback: comment,
      }
    });
    window.dispatchEvent(submitClickEvent);
   };

  const handleCancel = async () => {
    if (await isJsHandlersRegistered())
    {
      jsEventHandlers.cancelButton_Click();  // eslint-disable-line
      return;
    }

    // if jsEventHandlers is not defined in the browser instance, then we can
    // assume this is running in the context of a newer version of EHR which 
    // handles dispatchEvent
    let cancelClickEvent = new CustomEvent("CancelClick");
    window.dispatchEvent(cancelClickEvent);
  };

  const isJsHandlersRegistered = async() => {
    // check to see if we're running in the context of CefSharp
    // note: this is for backwards compatability with older versions of EHR which
    //       do not handle dispatchEvent
    if (typeof CefSharp === 'undefined')   // eslint-disable-line
      return false;

    await CefSharp.BindObjectAsync("jsEventHandlers");  // eslint-disable-line

    if (typeof jsEventHandlers === 'undefined')
      return false;

    if (jsEventHandlers) // eslint-disable-line
      return true;

    return false
  }

  const handleCommentChange = event => {
    setComment(event.target.value);
  };

  const [comment, setComment] = useState('');

  return (
    <div style={styles.container}>
        <label style={styles.label}>How would you rate your overall experience using NextGen EHR?</label>
        <div style={styles.stars}>
          {stars.map((_, index) => {
            return (
              <FaStar
                key={index}
                size={34}
                onClick={() => handleClick(index + 1)}
                onMouseOver={() => handleMouseOver(index + 1)}
                onMouseLeave={handleMouseLeave}
                color={(hoverValue || currentValue) > index ? colors.orange : colors.grey}
                style={{
                  marginRight: 10,
                  cursor: "pointer"
                }}
              />
            );
          })}
        </div>
        <label style={styles.label}>Do you have additional comments?</label>
        <textarea
          maxLength = "2000"
          placeholder="Do not include patient information in your comments"
          style={styles.textarea}
          value={comment}
          onChange={handleCommentChange}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '470px' }}>
          <button type="button" style={{ marginRight: '10px' }} onClick={handleCancel}>Ask Later</button>
          <button type="submit" onClick={handleSubmit} disabled={!isEnabled}>Submit</button>     
        </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    paddingLeft: "20px"
  },
  stars: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },
  textarea: {
    border: "1px solid #a9a9a9",
    borderRadius: 5,
    padding: 10,
    margin: "20px 0",
    minHeight: 90,
    width: 450,
    resize: "none",
    },
  placeholder: {
    position: "absolute",
    top: 0,
    pointerEvents: "none"
  },
  button: {
    border: "1px solid #a9a9a9",
    borderRadius: 5,
    width: 300,
    padding: 10,
  },
  label: {
    margin: "20px 0 20px 0"
  },
};

export default NPSApp;
